import { render, staticRenderFns } from "./VertexAndRoundDialog.vue?vue&type=template&id=581b00f0&scoped=true&"
import script from "./VertexAndRoundDialog.vue?vue&type=script&lang=js&"
export * from "./VertexAndRoundDialog.vue?vue&type=script&lang=js&"
import style0 from "./VertexAndRoundDialog.vue?vue&type=style&index=0&id=581b00f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b00f0",
  null
  
)

export default component.exports